const selectIsInProgress = (state) => state?.speedcurveState?.isInProgress;

export default selectIsInProgress;
